import { request } from "./http";

export type TimeInForce = "GTC" | "DAY" | "IOC" | "FOK";

export interface OrderRequest {
  symbol: string;
  asset_class?: string;
  side: "BUY" | "SELL";
  order_type: "MARKET" | "LIMIT" | "STOP" | "STOP_LIMIT";
  quantity: number;
  limit_price?: number | null;
  stop_price?: number | null;
  time_in_force?: TimeInForce;
  strategy_id?: string;
  /** Protective stop. After fill, attaches via POST /orders/{id}/modify. */
  stop_loss?: number | null;
  /** Profit target. After fill, attaches via POST /orders/{id}/modify. */
  take_profit?: number | null;
}

export interface OrderResponse {
  status: string;
  order_id: string;
  broker_id: string;
  routed_via: "user_broker" | "simulated";
  message: string;
}

export interface OrderListItem {
  order_id: string;
  symbol: string;
  side: string;
  qty: number;
  status: string;
  filled_qty: number;
  avg_fill_price: number | null;
  created_at: string;
}

export interface RestingLimit {
  id: string;
  trading_account_id: string;
  symbol: string;
  side: "BUY" | "SELL";
  price: string;
  qty_remaining: string;
  qty_original: string;
  status: "OPEN" | "PARTIAL";
  created_at: string;
}

export const orders = {
  list: () => request<{ orders: OrderListItem[]; summary: Record<string, number> }>("/piggy/api/orders"),
  create: (body: OrderRequest & { trading_account_id?: string }) =>
    request<OrderResponse>("/piggy/api/orders", { body }),
  close: (order_id: string) => request<unknown>(`/piggy/api/orders/${order_id}/close`, { method: "POST" }),
  modify: (order_id: string, body: { stop_loss?: number | null; take_profit?: number | null }) =>
    request<unknown>(`/piggy/api/orders/${order_id}/modify`, { body }),
  flatten: () => request<unknown>("/piggy/api/orders/flatten", { method: "POST" }),
  listLimits: (tradingAccountId?: string) => {
    const q = tradingAccountId ? `?trading_account_id=${tradingAccountId}` : "";
    return request<RestingLimit[]>(`/piggy/api/orders/limit${q}`);
  },
  cancelLimit: (id: string) =>
    request<{ id: string; status: string }>(`/piggy/api/orders/limit/${id}`, { method: "DELETE" }),
};
